import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const organizationFieldsFragment = gql`
  fragment AdminOrganizationFields on Organization {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    name,
    logo {
      _type,
      asset {
        _ref,
        _type
      }
    }
    auth0_tenant
    auth0_region
    organizationManagerEmails
  }

  ${sanityDocumentFieldsFragment}
`;